import type { DataUrl } from '../types';

/**
 * SVG 텍스트를 Data URL로 변환
 * @description
 * - Base64 인코딩을 사용하여 변환
 * - 메모리에서만 처리되므로 매우 빠름
 */
export function svgToDataUrl(svg: string): DataUrl {
  // UTF-8 문자열을 올바르게 base64로 인코딩
  // TextEncoder를 사용하여 UTF-8 바이트 배열로 변환 후 base64 인코딩
  const bytes = new TextEncoder().encode(svg);
  const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join('');
  const base64 = btoa(binString);
  return `data:image/svg+xml;base64,${base64}` as DataUrl;
}
